exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nspan[data-v-54211943]:after{content:' '\n}\n.symbol[data-v-54211943]{width:14px;height:14px;border:2px dotted #140601;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-right:3px\n}\n", ""]);

// exports
